var n = (o, t, e) => new Promise((y, s) => {
  var d = (r) => {
    try {
      i(e.next(r));
    } catch (a) {
      s(a);
    }
  }, g = (r) => {
    try {
      i(e.throw(r));
    } catch (a) {
      s(a);
    }
  }, i = (r) => r.done ? y(r.value) : Promise.resolve(r.value).then(d, g);
  i((e = e.apply(o, t)).next());
});
import { selfAxios as m } from "@oppein/op-utils";
function c(o) {
  return n(this, null, function* () {
    const {
      data: t
    } = yield m.post(
      "/designapi/design/orderStorageTime/queryOrderStorageTimeByQry",
      o
    );
    return t;
  });
}
export {
  c as postQueryOrderStorageTimeByQry
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designapi/design/orderStorageTime/queryOrderStorageTimeByQry/post.js
// module id = 1759
// module chunks = 41